import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { PravniFormaDataService } from "../pravni-forma-data/pravni-forma-data.service";
import { Field } from "../shared/detail/detail.service";
import { UcetniJednotkaDataService } from "../ucetni-jednotka-data/ucetni-jednotka-data.service";
import { UcetniJednotkaDetailService } from "./ucetni-jednotka-detail.service";
import {DialogService} from "../shared/dialog/dialog.service";
import {MasterDetailHub} from "../shared/master-detail/master-detail-hub.service";
import {ApiAttributeParams, MapperKeys} from "../shared/crud/abstractions/base-crud";
import {
  SestavenyVykazHlavickaDataService
} from "../data-services/sestaveny-vykaz-hlavicka/sestaveny-vykaz-data.service";
import {SestavenyVykazHlavickaDto} from "../data-services/sestaveny-vykaz-hlavicka/models/SestavenyVykazHlavickaDtos";
import {UctovyRozvrhDataService} from "../uctovy-rozvrh-data/uctovy-rozvrh-data.service";
import {DokladovaRadaDataService} from "../dokladova-rada-data/dokladova-rada-data.service";
import {MatDialog} from "@angular/material/dialog";
import {UcetniObdobiDataService} from "../ucetni-obdobi-data/ucetni-obdobi-data.service";


@Injectable()
export class UcetniJednotkaCreateDetailService extends UcetniJednotkaDetailService {

    constructor( ucetniObdobi: UcetniObdobiDataService,
      ucetniJednotkaDataService: UcetniJednotkaDataService,
                dokladovaRada: DokladovaRadaDataService,
                uctovyRozvrh: UctovyRozvrhDataService,
                router: Router,
                matDialog: MatDialog,
                private masterDetailHub: MasterDetailHub,
                private pravniFormaDataService: PravniFormaDataService,
                private dialogService: DialogService,
                private sestavenyVykazHlavickaDataService: SestavenyVykazHlavickaDataService) {
      super(ucetniObdobi,ucetniJednotkaDataService,dokladovaRada, uctovyRozvrh,router,matDialog)
      this.addObservable(this.settings.fieldsNew);
      this.addObservable(this.settings.fieldsEdit);
    }

    public getValueForCombo(id: string) {
        this.get(id);
    }


    async addObservable(columns: Field[]) {
      const mapped = this.ucetniJednotkaDataService.setMapper({key: MapperKeys.MaxResultCount, value: 2000})
        this.pravniFormaDataService.getAll({ params: mapped }).then(x => {
            x.forEach(item => item.displayValue = item.kod + " - " + item.nazev);

            let observableKodField = {
                observable: of(x),
                optionName: 'displayValue',
                optionValue: 'kod',
            };

            let field = columns.find(x => x.name === 'kodPravniFormy');
            if (field) {
                field.observable = observableKodField;
            }
        });
    }

    override async create(id: string, entity: any, override: boolean = false)
    {
      try
      {
        return super.create(id, entity, override);
      }
      catch (e)
      {
        await this.dialogService.handleError(e);
      }
    }

  override async edit(id: string, entity: any, from?: ApiAttributeParams) {
      const dict = new Map<string, any>([[MapperKeys.KodUj, id]]);
      const hlavicky = await this.sestavenyVykazHlavickaDataService.getAll({params: dict});
      const hlavickaVAktualnimObdobi = this.getAktulaniHlavicku(hlavicky);

      if(hlavickaVAktualnimObdobi.length === 1){
        const hlavicka = hlavickaVAktualnimObdobi[0];
        hlavicka.informaceUcetniJednotky.icoUcetniJednotky = entity.ico;
        await this.sestavenyVykazHlavickaDataService.edit(hlavicka.id, hlavicka);
      }
      return await super.edit(id, entity, from);
  }

  private getAktulaniHlavicku(hlavicky: SestavenyVykazHlavickaDto[]){
      const now = new Date();
      return hlavicky.filter(x => new Date(x.platnaOd) <= now
        && (new Date(x.platnaDo) >= now || x.platnaDo == null));
  }


}
